import { getIn } from 'seamless-immutable';
import FavoriteCacheMobileAcom from '../favorite-cache.graphql';

export const getFavorite = (data, isLogged, favoriteState) => {
  if (favoriteState.called) {
    return favoriteState.isFavorite;
  }
  if (isLogged) {
    return getIn(data, ['favorite', 'isFavorite']);
  }
  return false;
};

export const readFavoriteFromCache = cache => {
  const data = cache.readQuery({
    query: FavoriteCacheMobileAcom,
  });

  return data ? data : { isFavoriteOnCache: false };
};

export const writeFavoriteOnCache = ({ isFavoriteOnCache }, cache) => {
  cache.writeQuery({
    query: FavoriteCacheMobileAcom,
    data: { isFavoriteOnCache },
  });
};

export const closureAddFavorite = addFavoriteFn => () => {
  addFavoriteFn();
};
